import type { Language } from "../../types/i18n";

/*
 * UI strings for one area of the app, merged into `translations` (see
 * ./index.ts) so components read them through `useI18nStore().t` like every
 * other key. English is the reference; the other languages must carry the
 * same keys, which the record type enforces.
 */
const en = {
  fmtRadiusLabel: "Radius:",
  fmtFacilitiesWithin: "{count} facilities within {distance} of {place}",
};

export type FormattingStrings = typeof en;

export const formattingStrings: Record<Language, FormattingStrings> = {
  en,
  de: {
    fmtRadiusLabel: "Umkreis:",
    fmtFacilitiesWithin:
      "{count} Einrichtungen im Umkreis von {distance} um {place}",
  },
  fr: {
    fmtRadiusLabel: "Rayon :",
    fmtFacilitiesWithin:
      "{count} établissements dans un rayon de {distance} autour de {place}",
  },
  es: {
    fmtRadiusLabel: "Radio:",
    fmtFacilitiesWithin: "{count} centros en un radio de {distance} de {place}",
  },
  pt: {
    fmtRadiusLabel: "Raio:",
    fmtFacilitiesWithin: "{count} unidades num raio de {distance} de {place}",
  },
};
